<template>
    <div>
        <TUICallKit :class="callClass" />
        <router-view />
    </div>
</template>

<script>
import { computed } from 'vue'
import { TUICallKit } from '@tencentcloud/call-uikit-vue'

export default {
  components: { TUICallKit },
  setup () {
    const isH5 = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    const callClass = computed(() => {
      return isH5 ? 'call-uikit-h5' : 'call-uikit-pc'
    })
    return { callClass }
  }
}
</script>

<style>
.call-uikit-pc {
    width: 950px  !important;
    height: 650px  !important;
    position: absolute !important;
    z-index: 100;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
}

.call-uikit-h5 {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 200;
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.ani,
.ani * {
    transition-property: all;
    -ms-transition-property: all;
    -moz-transition-property: all;
    -webkit-transition-property: all;
    -o-transition-property: all;
    transition-duration: .3s;
    -ms-transition-duration: .3s;
    -moz-transition-duration: .3s;
    -webkit-transition-duration: .3s;
}

from,
div,
dl,
dd,
dt,
ol,
ul,
li,
a,
img,
input,
h1,
h2,
h3,
h4,
h5,
h6,
table,
a,
p,
form,
em,
i {
    margin: 0;
    padding: 0;
    border: 0;
    font-weight: normal;
}

ul,
li,
dl,
dd,
dt,
h1,
h2,
h3,
h4,
h5,
h6,
form,
em,
i {
    list-style-type: none;
    font-style: normal;
}

body {
    margin: 0;
    padding: 0;
    font: normal 1rem "Microsoft YaHei", "SimHei", "SimSun", "Helvetica Neue", Arial;
    color: #000;
    word-break: break-all;
    text-align: justify;
    background-color: #fff;
}

img,
li {
    vertical-align: top;
}

img {
    max-width: 100%;
}

input[type="submit"],
input[type="reset"],
input[type="button"],
button {
    appearance: none;
}

.clear {
    clear: both;
    width: 0;
    height: 0;
    border: 0;
    margin: 0;
    padding: 0;
    visibility: hidden;
    font-size: 0;
    line-height: 0;
}

.clearfix {
    zoom: 1;
}

.clearfix:after {
    content: "";
    display: block;
    clear: both;
    height: 0;
}

*:focus {
    outline: none;
}

a,
a:hover,
a:focus {
    text-decoration: none;
    color: #666;
}
</style>
